/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {DelContactListVO} from './del-contact-list-vo.model';
import {JSONable} from '@irian-ro/abstract-resource';

export class DelContactsModel extends JSONable {
  contextUuid: string | undefined = undefined;
  contactsList: DelContactListVO[] | undefined = undefined;
}
